const ACTION_SCOPE = '[Current User]';

export class LoadCurrentUser {
    public static readonly type = `${ACTION_SCOPE} Load`;

    public constructor(public readonly payload: { gid: string }) {}
}
